import { Fragment, isValidElement, useContext, useEffect, useState } from "react";
import { axiosInstance } from "../../axios/axiosInstance";
import { ImageWithDefault } from "../../Layout/Common/imageWithDefault";
import { isValidArray, normalizePath } from "../../Layout/Common/common";
import { Link, useLocation } from "react-router-dom";
import { GlobalContext } from "../../Context/GlobalContext";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { NewProductCategoryGrid } from "../../Layout/Common/newproductCategoryGrid";
import { categoryChildrenOf } from "../../utils/categoryIndex";
import { useCategoryLink } from "../../Context/hook/useCategoryLink";

export const SubCategoryGrid = ({ subcategoryList }) => {
  const [subcategory, setSubcategory] = useState();
  const [refinedData, setRefinedData] = useState(null);
  const { categoryDataAll, categoryIndex } = useContext(GlobalContext);
  const getCategoryLink = useCategoryLink();
  const { pathname } = useLocation();
  useEffect(() => {
    const loadSubcategorydata = async () => {
      const res = await axiosInstance.post("CategoryPage/GetSubCategory", {
        catUrl: pathname,
      });
      if (res.data) {
        setSubcategory(res.data);
        setRefinedData(res.data);
      } else {
        setSubcategory(null);
        setRefinedData(null);
      }
    };
    if (!isValidArray(categoryDataAll) || normalizePath(pathname).includes("new-products")) loadSubcategorydata();
    else {
      subcategoryList = null;
      var catDetail = categoryDataAll.find(
        (ct) => String(ct.url).replace(/^\/|\/$/g, "") == pathname.replace(/^\/|\/$/g, ""),
      );
      if (catDetail) {
        var subcatDetail = categoryChildrenOf(categoryIndex, catDetail.categoryId);
        setSubcategory(subcatDetail);
        setRefinedData(subcatDetail);
      }
    }
  }, [pathname]);

  useEffect(() => {
    if (isValidArray(subcategory) && isValidArray(subcategoryList)) {
      console.log("subcategory", subcategory);
      console.log("subcategoryList", subcategoryList);
      const filtered = subcategory.filter((itemA) =>
        subcategoryList.some((itemB) => itemB.label == itemA.categoryName),
      );
      setRefinedData(filtered);
    }
  }, [subcategoryList]);

  return (
    <Fragment>
      {isValidArray(refinedData) && (
        <TransitionGroup className={"row row-spacing"}>
          {refinedData.map((row, index) => {
            return (
              <CSSTransition key={row.categoryId} timeout={500} classNames="fade">
                {normalizePath(pathname).includes("new-products") ? (
                  <NewProductCategoryGrid row={row} />
                ) : (
                  <div className="col-6 col-sm-6 col-lg-3 mt-3" key={row.categoryId}>
                    <div className="ct-subcategories">
                      <Link to={getCategoryLink(row.categoryId, row.categoryUrl ?? row.url)}>
                        <div>
                          <p>{row.categoryName}</p>
                        </div>
                        <div className="ct-subcategories-img">
                          <ImageWithDefault
                            src={row.categoryImage ?? row.image}
                            alt="sub category"
                            wrapperClassName="img-center"
                          />
                        </div>
                      </Link>
                    </div>
                  </div>
                )}
              </CSSTransition>
            );
          })}
        </TransitionGroup>
      )}
    </Fragment>
  );
};
